import script from "./ProgramDetailsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ProgramDetailsDialog.vue?vue&type=script&setup=true&lang=js"

import "./ProgramDetailsDialog.vue?vue&type=style&index=0&id=30ae26e2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30ae26e2"]])

export default __exports__